// Locales - common
import common_en from "../../../../libs/ps/restaumatic-common/locales/en.json";

export default {
  en: { _common: common_en },
};
